export default "/assets/website/images/address_empty_icon.svg?b04fd77558a0016427b5e8058cd9a139";